
import { ComponentInterface } from '@fusioncharts/core/src/component-interface';

class HeatMapGroup extends ComponentInterface {
  /**
   * constructor function this class
   */
  constructor () {
    super();
    this.setState('visible', true);
    this.getDataLimits = null;
  }

  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'group';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'heatMapGroup';
  }

  /**
   * Create child containers
   */
  createContainer () {
    let manager = this,
      key,
      parent = manager.getLinkedParent(),
      animationManager = manager.getFromEnv('animationManager'),
      pContainer,
      parentChildContainers = parent.getChildContainer();

    for (key in parentChildContainers) {
      pContainer = parentChildContainers[key];

      !manager.getChildContainer(key) && manager.addChildContainer(key,
        animationManager.setAnimation({
          el: 'group',
          attr: { name: 'manager-' + key },
          container: pContainer,
          component: manager,
          label: 'group'
        }));
    }
  }

  getLimits (allVisible) {
    let manager = this,
      min = +Infinity,
      max = -Infinity,
      maxminObj,
      numOfColumns = 0,
      getMaxMin = function (_maxminObj) {
        max = Math.max(max, _maxminObj.max);
        min = Math.min(min, _maxminObj.min);
      };

    manager._mapChildren((child) => {
      if (child.getState('removed') || (child.getState('visible') === false)) {
        if (allVisible) {
          maxminObj = child.getDataLimits(allVisible);
          getMaxMin(maxminObj);
        }
        return;
      }
      numOfColumns++;
      maxminObj = child.getDataLimits(allVisible);
      getMaxMin(maxminObj);
    });
    if (!numOfColumns) {
      manager.setState('visible', false);
    } else {
      manager.setState('visible', true);
    }
    if (!this.config.range) {
      this.config.range = {};
      this.config.range.min = this.config.dataMin;
      this.config.range.max = this.config.dataMax;
    }
    return { max, min };
  }
  /**
   * function call sync draw of its children
   */
  draw () {
    var manager = this,
      range = manager.getLimits(true);
    manager.addToEnv('datasetMinValue', range.min);
    manager.addToEnv('datasetMaxValue', range.max);
    this.createContainer();
  }

  getAxisValuePadding () {
    let paddingObj = {},
      axisPaddingLeft = -Infinity,
      axisPaddingRight = -Infinity,
      axisPaddingTop = -Infinity,
      axisPaddingBottom = -Infinity;
    this._mapChildren((child) => {
      if (child.getState('removed')) {
        return;
      }
      paddingObj = (child.getAxisValuePadding && child.getAxisValuePadding()) || {};
      axisPaddingLeft = Math.max(axisPaddingLeft, paddingObj.left || -Infinity);
      axisPaddingRight = Math.max(axisPaddingRight, paddingObj.right || -Infinity);
      axisPaddingTop = Math.max(axisPaddingTop, paddingObj.top || -Infinity);
      axisPaddingBottom = Math.max(axisPaddingBottom, paddingObj.bottom || -Infinity);
    });
    if (axisPaddingLeft === -Infinity) {
      axisPaddingLeft = 0;
    }
    if (axisPaddingRight === -Infinity) {
      axisPaddingRight = 0;
    }
    if (axisPaddingTop === -Infinity) {
      axisPaddingTop = 0;
    }
    if (axisPaddingBottom === -Infinity) {
      axisPaddingBottom = 0;
    }
    if (!this.config.padding) {
      this.config.padding = {};
      this.config.padding.left = axisPaddingLeft;
      this.config.padding.right = axisPaddingRight;
      this.config.padding.top = axisPaddingTop;
      this.config.padding.bottom = axisPaddingBottom;
    }
    return {
      left: axisPaddingLeft,
      right: axisPaddingRight,
      top: axisPaddingTop,
      bottom: axisPaddingBottom
    };
  }
}
export default HeatMapGroup;
